import React from 'react';
import { Box, Divider, IconButton, Stack, Typography } from '@mui/joy';
import CloseIcon from '@mui/icons-material/Close';
import DocumentViewerDrawer from '../../../components/DocumentViewerDrawer';
import TaskResultDrawer from '../../../components/TaskResultDrawer';
import PolicyViewerDrawer from './PolicyViewerDrawer';

const AgentSidebar = ({
  items = [],
  onCloseItem,
  onDocTextQuote,
  onDocRegionCrop,
  onPolicyQuote,
}) => {
  const open = items.length > 0;

  return (
    <Box
      aria-hidden={!open}
      sx={{
        flexBasis: open ? { xs: '100%', md: '45vw' } : '0px',
        width: open ? { xs: '100%', md: '45vw' } : '0px',
        minWidth: 0,
        maxWidth: open ? { xs: '100%', md: '750px' } : '0px',
        opacity: open ? 1 : 0,
        transform: open ? 'translateX(0)' : 'translateX(100%)',
        pointerEvents: open ? 'auto' : 'none',
        borderLeftStyle: 'solid',
        borderLeftWidth: open ? '1px' : '0px',
        borderColor: 'divider',
        bgcolor: 'background.surface',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flexShrink: 0,
        overflow: 'hidden',
        willChange: 'flex-basis, width, max-width, transform, opacity',
        transition:
          'flex-basis 380ms cubic-bezier(0.4, 0, 0.2, 1), width 380ms cubic-bezier(0.4, 0, 0.2, 1), max-width 380ms cubic-bezier(0.4, 0, 0.2, 1), opacity 220ms ease, transform 380ms cubic-bezier(0.4, 0, 0.2, 1), border-left-width 380ms cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      {items.map((item, idx) => (
        <React.Fragment key={item.id}>
          <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            {item.type === 'document' && (
              <DocumentViewerDrawer
                noWrapper
                open
                onClose={() => onCloseItem(item.id)}
                document={item.data}
                onTextQuote={onDocTextQuote}
                onRegionCrop={onDocRegionCrop}
              />
            )}
            {item.type === 'policy' && (
              <PolicyViewerDrawer
                noWrapper
                open
                onClose={() => onCloseItem(item.id)}
                policy={item.data}
                loading={item.loading}
                onQuote={onPolicyQuote}
                focusFieldKey={item.fieldKey}
              />
            )}
            {item.type === 'task' && (
              <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    px: 2,
                    py: 1.5,
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    flexShrink: 0,
                  }}
                >
                  <Typography level="title-md" noWrap sx={{ fontWeight: 600 }}>
                    Task #{item.taskId}
                  </Typography>
                  <IconButton
                    size="sm"
                    variant="plain"
                    color="neutral"
                    onClick={() => onCloseItem(item.id)}
                    aria-label={`Close task ${item.taskId} sidebar`}
                  >
                    <CloseIcon />
                  </IconButton>
                </Stack>
                <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
                  <TaskResultDrawer
                    taskId={item.taskId}
                    result={item.data?.result}
                    input={item.data?.input}
                    isLoading={item.loading}
                    isOpen
                  />
                </Box>
              </Box>
            )}
          </Box>
          {idx < items.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default AgentSidebar;
